import React, {Component} from 'react';
import BsyIconBtn from "../BsyIconBtn";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import './index.css'
import * as XLSX from "xlsx";

class AlertBatchImport extends Component {
    state = {
        nocheck: false,
        excelName: "",
        excelTotal: "",
        errTipShow: false,
        errCount: 0,
        existCount: 0,
        newCount: 0,
        excelTable: []
    }

    doneClick = () => {
        this.setState({
            nocheck: false,
            excelName: "",
            excelTotal: "",
            errTipShow: false,
            errCount: 0,
            existCount: 0,
            newCount: 0,
            excelTable: []
        })
    }
    downErrorInfo = () => {
        const { errInfo } = this.state
        React.axios(`/manager/team/${window.FX.Utils.getCurrentCorp()}/roledownloader`, {
            excel: errInfo
        }).then(res => {
            var h = res.data.data;
            if (h.success > 0) {
                window.location.href = h.info;
            }
        }).catch(res => {

        })
    }

    _s2ab = (s) =>{
        let buf = new ArrayBuffer(s.length);
        let view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }

    downFile = () => {
        let template = [{}];
        const formItems = ["账号"]
        for( let k = 0; k <  formItems.length ; k++)
        {
            template[0][formItems[k]] = React.language("Test.account");
        }
        let wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };
        let wb = { SheetNames: ['Sheet1'], Sheets: {}, Props: {} };
        wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(template);
        let down = new Blob([this._s2ab(XLSX.write(wb, wopts))], { type: "application/octet-stream" });
        let href = URL.createObjectURL(down);
        let link = document.createElement('a');
        link.href = href;
        link.download = "角色导入模板.xlsx";

        let event;
        if (window.MouseEvent) event = new MouseEvent("click");
        else {
            event = document.createEvent("MouseEvents");
            event.initMouseEvent(
                "click",
                true,
                false,
                window,
                0,
                0,
                0,
                0,
                0,
                false,
                false,
                false,
                false,
                0,
                null
            );
        }
        link.dispatchEvent(event);
    }

    importClick = () => {
        const { excelTable } = this.state
        const { role, roleRefresh } = this.props
        const c = window.FX.Utils.createLoadLayer(window.$('.invite-body'), {
            isLight: !0,
            hasLoader: !0
        });
        React.axios(`/corp/role/${role.role_id}/importvalue`, {
            corpId: window.FX.Utils.getCurrentCorp(),
            excel: excelTable
        }).then(res => {
            c.remove()
            const data = res.data
            if (data.hasOwnProperty("msg") && data.hasOwnProperty("code") && data.code > 0) {
                tipAlert({
                    type: "warning",
                    msg: data.msg
                })
                return;
            }

            if (data.code <= 0) {
                this.setState({
                    errInfo: data.errdata,
                    excelTable: data.data,
                    errCount: data.errcount,
                    existCount: data.existcount,
                    newCount: data.newcount,
                    errTipShow: true
                })
                if (data.newcount > 0) {
                    roleRefresh && roleRefresh(role)
                }
            } else {
                tipAlert({
                    type: "warning",
                    msg: '系统错误，导入失败'
                })
            }
        }).catch(res => {
            window.FX.Vip.showUpgradeTip(res.responseJSON)
        })
    }

    _column_2_number = (s) => {
        let result = 0;
        let len = s.length;
        let ch;
        let A = 'A'.charCodeAt();
        for (let i = len - 1; i >= 0; i--) {
            ch = s[i];
            ch = s.charCodeAt(i);
            result = (result + ((ch - A) + 1) * Math.pow(26, len - 1 - i));
        }
        return result;
    }

    _parse_sample_ex2 = (a) => {
        let y_s = 0;
        let x_e = 0;
        let y_e = 0;
        let ref = a['!ref']
        let reg1 = /([a-zA-Z]+)([0-9]+):([a-zA-Z]+)([0-9]+)/ig;
        let res1 = reg1.exec(ref)
        y_s = Number(res1[2]) - 1;
        x_e = this._column_2_number(res1[3]);
        y_e = Number(res1[4]);
        let result = new Array(y_e > 500 ? 500 : y_e);
        let array_value = new Array(y_e);
        for (let i = y_s; i < y_e; i++) {
            array_value[i] = [];
            if (i < 500)
                result[i] = [];
            for (let j = 0; j < x_e; j++) {
                array_value[i][j] = "";
                if (i < 500)
                    result[i][j] = {};
            }
        }
        for (let k in a) {
            let reg = /([a-zA-Z]+)([0-9]+)/ig;
            let res = reg.exec(k)
            if (!res)
                continue;
            let x = this._column_2_number(res[1]) - 1;
            let y = Number(res[2]) - 1;
            let val = { value: a[k].v, type: a[k].t };
            if (y < 500)
                result[y][x] = val;
            array_value[y][x] = a[k].v;
        }
        this.setState({
            array_value: array_value,
            excelTotal: array_value.length - 1
        })
        return result;
    }

    _previewExcelData = (a1, event) => {
        const txt = React.language('role.import.tip');
        // eslint-disable-next-line no-unused-vars
        let { cacheKey, sheetName, formName, excel_data, cuurmobiletype } = this.state
        let wb;
        let f = a1[0];
        let reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            wb = XLSX.read(data, { type: 'binary' });
            cacheKey = a1.cacheKey;
            sheetName = wb.SheetNames[0];
            var b = a1;
            a1 = [];
            a1.sheetList = wb.SheetNames;
            formName = React.language("import.form");
            if (b && b.length > 0) {
                (formName = b[0].name.replace(".xlsx", "").replace(".xls", ""));
                if (wb.Sheets[sheetName].hasOwnProperty("!merges")) {
                    tipAlert({
                        type: "warning",
                        msg: txt
                    });
                    event.target.value = '';
                }
                else {
                    //必填手机号码，手机号码为空直接过滤当前数据
                    excel_data = wb.Sheets;
                    let items = this._parse_sample_ex2(wb.Sheets[sheetName]), g = true;
                    let array_value = [];
                    cuurmobiletype = false;
                    if (items.length > 0) {
                        //unique
                        if (g) {
                            if ((array_value.length - 1) <= 200) {
                                this.setState({ excelName: f.name.replace(".xlsx", "").replace(".xls", ""), excelTable: items })
                                event.target.value = '';
                            } else {
                                tipAlert({
                                    type: "warning",
                                    msg: '数据条数超过限制，最大值为200条'
                                });
                                event.target.value = '';
                            }
                        } else {
                            tipAlert({
                                type: "warning",
                                msg: txt
                            });
                            event.target.value = '';
                        }
                    } else {
                        tipAlert({
                            type: "warning",
                            msg: txt
                        });
                        event.target.value = '';
                    }
                }
            }
        }

        reader.readAsBinaryString(f);
    }

    uploadFile = (event) => {
  
        const img = event.target.files;
        this._previewExcelData(img, event);
    }

    render() {
        const {excelName, excelTotal, excelTable, errTipShow, errCount, existCount, newCount, nocheck} = this.state
        return (
            <div className={"AlertBatchImport " + window.mode}>
                <div className="batchInvite">
                    {errTipShow ? <div className="batchErrTip">
                        <div className="errorTip">
                            {React.language('batch.error.tip', { success: newCount, exist: existCount, error: errCount })}
                        </div>
                        <div className="errorBtn">
                            <BsyIconBtn
                                text={React.language('batch.error.btn')}
                                type="white"
                                click={this.downErrorInfo}
                                mode={window.mode}
                            />
                        </div>
                    </div> : <div className="batchBtn">
                        <div className={"r-btn " + window.mode}>
                            <i className="icon-bsy-file" />
                            <span>{React.language('widget.file.select')}</span>
                            <form className="upload-form " action="" encType="multipart/form-data"
                                  method="post">
                                <input onChange={this.uploadFile} type="file" name="file" id="file"
                                       className="upload-btn-input" accept=".xlsx,.xls" />
                            </form>
                        </div>
                        <BsyIconBtn
                            text={React.language('Download.btn1')}
                            iconName="icon-bsy-reportmenu-8"
                            type="r-btn white "
                            click={this.downFile}
                            mode={window.mode}
                        />
                    </div>}
                    {excelTable.length <= 0 && <div className="batchTip">
                        <p>{React.language("Download.tip")}</p>
                        <ul>
                            <li>{React.language("Download1")}</li>
                            <li>{React.language("Download2")}</li>
                            <li>{React.language("Download3")}</li>
                        </ul>
                    </div>}
                    {excelTable.length > 0 && <div className="batchTable">
                        <div className="invite-content">
                            <div className="excel-import-tool">
                                <span>{React.language('excel')}-{excelName}</span>
                                <span style={{ float: 'right' }}>{React.language("Total.data")}{excelTotal}{React.language('tiao')}</span>
                            </div>
                            <div className="excel-import-table">
                                <div className={"excel-import-grid react_excel_grid " + (errTipShow ? "import" : "")}
                                     style={{ width: 'auto', maxHeight: '160px' }}>
                                    <div className="excel-border">

                                    </div>
                                    <table cellPadding="0" cellSpacing="0">
                                        <tbody>
                                        <tr className="row-head">
                                            <td className="row-idx" rowSpan="1"><span
                                                className="row-num">1</span><span
                                                className="row-label">{React.language('import.rowHead')}</span>
                                            </td>
                                            {
                                                excelTable[0].map((val, key) => {
                                                    return <td key={key}><span>{val.value}</span></td>
                                                })
                                            }
                                        </tr>
                                        {
                                            excelTable.map((val, key) => {
                                                return key !== 0 && <tr key={key}>
                                                    <td className="row-idx" rowSpan="1"><span
                                                        className="row-num">{key + 1}</span><span
                                                        className="row-label">{React.language('import.rowHead')}</span>
                                                    </td>
                                                    {
                                                        val.map((val1, key1) => {
                                                            return <td key={key1}><span>{val1.value}</span></td>
                                                        })
                                                    }
                                                </tr>
                                            })
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {errTipShow ? <div className="invite-btn">
                            <BsyIconBtn
                                text={React.language('done')}
                                type="blue"
                                click={this.doneClick}
                                mode={window.mode}
                            />
                        </div> : <div className="invite-btn">
                            <BsyIconBtn
                                text={React.language('import')}
                                type="blue"
                                click={this.importClick}
                                mode={window.mode}
                            />
                            <BsyIconBtn
                                text={React.language('cancel')}
                                type="white"
                                click={this.doneClick}
                                mode={window.mode}
                            />
                        </div>}
                    </div>}
                </div>
            </div>
        );
    }
}

export default AlertBatchImport;